import { useEffect } from "react";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import spin from "../../../assets/icons/spin.png";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import { CYLINDER_SETUP } from "../../../api/allApi_List";
import CylinderJobCardManager from "../components/jobcard-history/CylinderJobCardManager"

const JobCardHistoryPage = () => {
  const { data, isLoaded, error, getData } = useGetData();

  useEffect(() => {
    getData(CYLINDER_SETUP);
  }, []);

  return (
    <MainPageLayout headerConfig={{ title: "Cylinder Job Card History" }} bgColor="bg-dBlue-100">
 
      {isLoaded && !error ? (
        <CylinderJobCardManager setupData={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default JobCardHistoryPage;
